import { dollar, Chat, NeutralEmoji, Lock } from "../components/images/svg/icons";

export const Challenges = [
  {
    icon: dollar,
    title: "CHALLENGES_TITLE_1",
    description: "CHALLENGES_TITLE_1_DESC",
  },
  {
    icon: Lock,
    title: "CHALLENGES_TITLE_2",
    description: "CHALLENGES_TITLE_2_DESC",
  },
  {
    icon: Chat,
    title: "CHALLENGES_TITLE_3",
    description: "CHALLENGES_TITLE_3_DESC",
  },
  {
    icon: NeutralEmoji,
    title: "CHALLENGES_TITLE_4",
    description: "CHALLENGES_TITLE_4_DESC",
  },
];
